import type { FaireProductEntity } from "../../entity_types/product";

export const p_n82hmxb9hv: FaireProductEntity = {
  token: "p_n82hmxb9hv",
  type: "product",
  name: "Floating Mahjong Tile Mat in Neon Floral Pink",
  brandToken: "b_5symgoahr8",
  brandName: "Girl Tribe Co",
  imageUrl:
    "https://cdn.faire.com/fastly/bcface1ab8ac6ca1e48b4f3359d33b01b08c6f7437975dad501035c099574430.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/550da281a8ea8946b5dcf183db5438f8697e3b579e546157cc368747dc60e579.png",
    "https://cdn.faire.com/fastly/9d90414a6bca3ab7922467318ef2539785c6f6c966377c7ac898ab875dafe4b6.png",
    "https://cdn.faire.com/fastly/c4de69cfcc12ab9cafda76857fd97049075103f64f7d6e260c675bb9a7a87de7.png",
    "https://cdn.faire.com/fastly/d092167e190268fa57441f78eb3d5cfaa212b53983e6fb3ee67fd98e0b4ca6d4.png",
    "https://cdn.faire.com/fastly/f2d394a1da7f1d44159f8da226f5cefeac66601f07a40a6f989d8f3f9f3758c7.png",
  ],
  priceDollars: 97.5,
  description:
    'Playing Mahjong in the Pool? Grand Idea!\n\nCheck out our newest Girl Tribe Floating Mahjong Mat\n\nPre-Order: will ship After June 1\n\nIncludes Built in Rack\n\nDimensions: 33"x33"x2\n\n',
  tags: [],
  msrpDollars: 195,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:31.081Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
